import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

const INVESTIDOR_PREFIX = `${APP_PREFIX_PATH}/investidor`;

const Marketplace = lazy(() => import("./marketplace"));
const MinhasPropostas = lazy(() => import("./minhas-propostas"));

export const InvestidorViews = () => {
	useEffect(() => {
		if (JwtAuthService.isLogged()) {
			MenuService.populateMenuData().catch(() => {});
		}
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${INVESTIDOR_PREFIX}/marketplace`}
					component={Marketplace}
				/>
				<Route
					path={`${INVESTIDOR_PREFIX}/minhas-propostas`}
					component={MinhasPropostas}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${INVESTIDOR_PREFIX}/marketplace`}
				/>
			</Switch>
		</Suspense>
	);
};

export default InvestidorViews;
